<template>
  <FormModal :header="modalHeader" :name="name">
    <FormModalBody
      footer-button-text="Save"
      :is-button-loading="form.processing"
      @submit="saveForm"
    >
      <FormSelect
        v-model="form.nameParameterized"
        :options="tools"
        :is-error="Boolean(form.errors.name)"
        :errors="form.errors.name"
        @input="form.clearErrors('name')"
        is-required
      >
        <template #label>Tool</template>
      </FormSelect>
      <FormSelect
        v-model="form.from"
        :is-error="Boolean(form.errors.from)"
        :errors="form.errors.from"
        @input="form.clearErrors('from')"
        wrapper-classes="tw-mt-4"
        :options="yearsOptions"
        is-required
      >
        <template #label>Experience from</template>
      </FormSelect>
      <FormInput
        v-model="form.description"
        :is-error="Boolean(form.errors.description)"
        :errors="form.errors.description"
        @input="form.clearErrors('description')"
        class="tw-mt-4"
        as="textarea"
        rows="4"
        placeholder="Describe your experience..."
        is-required
        :min-characters="150"
        :max-characters="500"
      >
        <template #label>Description</template>
      </FormInput>
    </FormModalBody>
  </FormModal>
</template>

<script setup>
import _capitalize from 'lodash/capitalize'
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import FormInput from '@/shared/components/forms/FormInput.vue'
import { getYearsOptionsList } from '@/shared/utils/dates/yearsOptionsList.js'
import FormSelect from '@/shared/components/forms/FormSelect.vue'
import { useFormDates } from '@/shared/composables/useFormDates.js'
import { useForm, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { useModals } from '@/shared/composables/useModals.js'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  mode: {
    type: String,
    required: true,
    validator: function (value) {
      return ['EDIT', 'ADD'].includes(value.toUpperCase())
    },
  },
  tool: {
    type: Object,
    default: () => ({
      name: null,
      nameParameterized: null,
      from: null,
      description: null,
    }),
  },
})

const page = usePage()
const { getYearFromDateString } = useFormDates()
const { closeModal } = useModals()

const form = useForm({
  ...props.tool,
  from: getYearFromDateString(props.tool.from),
})

const modalHeader = computed(() => `${_capitalize(props.mode)} Tool`)
const yearsOptions = computed(() => getYearsOptionsList())
const tools = computed(() => page.props.softwareSpecialties)

const saveForm = () => {
  const method = props.mode === 'EDIT' ? 'patch' : 'post'
  const url =
    props.mode === 'EDIT'
      ? `/profile/mentor/software_specialties/${props.tool.id}`
      : '/profile/mentor/software_specialties'

  form
    .transform((form) => ({
      software_specialty: {
        name: form.nameParameterized,
        from: form.from && `${form.from}-01-01`,
        description: form.description,
      },
    }))
    [method](url, {
      preserveScroll: true,
      onSuccess: () => {
        closeModal(props.name)
        // resetForm()
        // router.reload({ only: ['reviewsOrdered'] })
      },
    })
}

// resetForm() {
//   this.form = this.$inertia.form({
//     ...this.tool,
//     from: this.getYearFromDateString(this.tool.from),
//   })
// },
</script>
